import { Flex, rem, Skeleton, Text } from "@mantine/core";
import classes from "./index.module.css";

/** Um bloco da aba: título e rótulo fixos (reais); select e explicação vêm do setor. */
function SettingBlockSkeleton({
  title,
  label,
}: {
  title: string;
  label: string;
}) {
  return (
    <Flex
      direction="column"
      gap={rem(10)}>
      <Text
        component="h2"
        ff="heading"
        className={classes.title}>
        {title}
      </Text>
      <Text className={classes.label}>{label}</Text>
      <Skeleton
        h={rem(36)}
        maw={rem(430)}
        radius="md"
      />
      <Skeleton
        h={rem(16)}
        maw={rem(390)}
        radius="sm"
      />
    </Flex>
  );
}

/**
 * Esqueleto de carregamento da aba Atendimentos, no mesmo formato da aba:
 * títulos e rótulos reais, só os selects, as explicações e o "Salvar"
 * esqueletizados.
 */
export function AttendingTabSkeleton() {
  return (
    <Flex
      direction="column"
      gap={rem(32)}
      className={classes.root}>
      <SettingBlockSkeleton
        title="Resposta inicial"
        label="Em qual inbox os novos chats irão aparecer"
      />
      <SettingBlockSkeleton
        title="Retomada de conversas encerradas"
        label="Quem atende quando o cliente volta a falar"
      />
      <Skeleton
        h={rem(36)}
        w={rem(126)}
        radius="sm"
      />
    </Flex>
  );
}

export default AttendingTabSkeleton;
